export const LEAD_EVENT_STAGES = Object.freeze({
  BASIC_PROFILE: 'BASIC_PROFILE',
  PERSONAL_DETAILS: 'PERSONAL_DETAILS',
  VEHICLE_INFO: 'VEHICLE_INFO',
  DRIVER_LICENSE_UPLOAD: 'DRIVER_LICENSE_UPLOAD',
  TRAINING_CERTIFIED: 'TRAINING_CERTIFIED',
  EXTERNAL_VALIDATION_REQUEST: 'EXTERNAL_VALIDATION_REQUEST',
});
